import 'nprogress/nprogress.css';
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from "store/app/store";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { routerConfig } from './routes';

const root = createRoot(
	document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
	{
		path: '/*',
		element: <App />,
		children: routerConfig,
	  },
])

root.render(
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<RouterProvider router={router} />
		</PersistGate>
	</Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
